import { useEffect } from 'react';
import { useWorkflows } from '@/store/workflows';

export function Toaster() {
  const toasts = useWorkflows((s) => s.toasts);
  const dismiss = useWorkflows((s) => s.dismissToast);

  useEffect(() => {
    const timers = toasts.map((t) =>
      window.setTimeout(() => dismiss(t.id), 4200)
    );
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [toasts, dismiss]);

  return (
    <div className="pointer-events-none fixed top-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 items-center">
      {toasts.slice(-5).map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto rounded-full border border-ink-800 bg-ink-900/95 backdrop-blur px-3.5 py-1.5 text-xs text-ink-200 shadow-lg shadow-black/40"
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
